import { ProductPage } from "./ProductPage";
import { SizeChart, TEE_ROWS } from "./SizeChart";

const TEES = [
  {
    id: "regular",
    name: "The Regular",
    description:
      "The everyday classic. A clean, comfortable tee with a timeless fit — made to be worn on repeat, in and out of the gym.",
    image: "/products/regular-black.jpg",
    hoverImage: "/products/regular-white.jpg",
    hoverHint: "Hover to see in white",
    shop: {
      id: "tee-regular",
      name: "The Regular Tee",
      price: 35,
      colours: ["Black", "White"],
    },
  },
  {
    id: "hyrox",
    name: "The Hyrox",
    description:
      "Still your everyday tee, with a Hyrox touch. The same clean, comfortable fit as The Regular.",
    image: "/products/hyrox-front.jpg",
    hoverImage: "/products/hyrox-back.jpg",
    hoverHint: "Hover to see back",
    shop: {
      id: "tee-hyrox",
      name: "The Hyrox Tee",
      price: 35,
      colours: ["Charcoal"],
    },
  },
];

const SCRATCHBOOK = {
  heading: "How the tees are made.",
  subheading:
    "Pages from the workshop floor — from the fabric shelf to the final check.",
  pages: [
    {
      src: "https://images.unsplash.com/photo-1583836815700-ba0649cf1faa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHx0ZXh0aWxlJTIwZmFicmljJTIwcm9sbHMlMjBzaGVsdmVzfGVufDB8fHx8MTc5MDQ1NTgyMXww&ixlib=rb-4.1.0&q=85",
      caption: "01 — Picking the fabric",
      rotate: "-rotate-2",
    },
    {
      src: "https://images.unsplash.com/photo-1764298493231-59ae059cdc7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxjdXR0aW5nJTIwZmFicmljJTIwc2Npc3NvcnMlMjBwYXR0ZXJufGVufDB8fHx8MTc5MDQ1NTgxNnww&ixlib=rb-4.1.0&q=85",
      caption: "02 — Cutting the pattern",
      rotate: "rotate-1",
    },
    {
      src: "https://images.unsplash.com/photo-1606501126768-b78d4569d3f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxmYWJyaWMlMjBjdXR0aW5nJTIwc2V3aW5nJTIwd29ya3Nob3B8ZW58MHx8fHwxNzkwNDU1NTEwfDA&ixlib=rb-4.1.0&q=85",
      caption: "03 — Stitching it together",
      rotate: "-rotate-1",
    },
    {
      src: "https://images.unsplash.com/photo-1663433567177-9f94be0bff4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxpbnNwZWN0aW5nJTIwZ2FybWVudCUyMHN0aXRjaGluZyUyMHQtc2hpcnR8ZW58MHx8fDE3OTA0NTU4MjF8MA&ixlib=rb-4.1.0&q=85",
      caption: "04 — Printing the mark",
      rotate: "rotate-2",
    },
    {
      src: "https://images.unsplash.com/photo-1776278792426-6e6861625b0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxpbnNwZWN0aW5nJTIwZ2FybWVudCUyMHN0aXRjaGluZyUyMHQtc2hpcnR8ZW58MHx8fDE3OTA0NTU4MjF8MA&ixlib=rb-4.1.0&q=85",
      caption: "05 — Final check",
      rotate: "-rotate-2",
    },
  ],
};

export const Tee = () => (
  <ProductPage
    testId="tee"
    title="The Tee"
    intro="Two takes on the same everyday essential. The Regular keeps it clean; The Hyrox adds a Training Club touch."
    variants={TEES}
    scratchbook={SCRATCHBOOK}
  >
    <SizeChart product="Tee" rows={TEE_ROWS} />
  </ProductPage>
);
